import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { Icon } from '../Component';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_stock_movement_suspension_settings, loading_retrieve_stock_movement_suspension_settings, reset_retrieve_stock_movement_suspension_settings, success_retrieve_stock_movement_suspension_settings } from '../../reducers/auth_tenant/retrieve_stock_movement_suspension_settings_Slice';
import { RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG, RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG, UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG, UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';
import * as app_consts from "../../utils/app_consts";
import { RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API, UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API } from '../../api/api_data';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_update_stock_movement_suspension_settings, loading_update_stock_movement_suspension_settings, reset_update_stock_movement_suspension_settings, success_update_stock_movement_suspension_settings } from '../../reducers/auth_tenant/update_stock_movement_suspension_settings_Slice';

const initial_state = { disable_on_webstore: false, disable_on_employee_dashboard: false, webstore_message: "", employee_dashboard_message: "" };

const ViewStockMovementSuspensionSettingsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initial_state);
  const [employees, setEmployees] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");


  useEffect(() => {
    if (isOpen)
    {
      setFormData(initial_state);
      // Dispatch
      retrieve_stock_movement_suspension_settings();
    }
    setOpen(isOpen);
    setEditMode(false);
    setUpdateError(false);
  }, [isOpen]);

  const retrieve_stock_movement_suspension_settings = () => {
    setError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_retrieve_stock_movement_suspension_settings, success_retrieve_stock_movement_suspension_settings, fail_retrieve_stock_movement_suspension_settings, RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG, RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API}`));
  };
  // Listen
  const retrieve_stock_movement_suspension_settings_listener = useSelector((state) => state.retrieve_stock_movement_suspension_settings.retrieve_stock_movement_suspension_settings);

  useEffect(() => {
    if (retrieve_stock_movement_suspension_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_stock_movement_suspension_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_stock_movement_suspension_settings_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_stock_movement_suspension_settings_listener.message);
          messageToast(retrieve_stock_movement_suspension_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_stock_movement_suspension_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_stock_movement_suspension_settings_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_stock_movement_suspension_settings());
      }
    }
  }, [retrieve_stock_movement_suspension_settings_listener]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_update_stock_movement_suspension_settings, success_update_stock_movement_suspension_settings, fail_update_stock_movement_suspension_settings, UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG, UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_API}`, formData));
  };
  // Listen
  const update_stock_movement_suspension_settings_listener = useSelector((state) => state.update_stock_movement_suspension_settings.update_stock_movement_suspension_settings);

  useEffect(() => {
    if (update_stock_movement_suspension_settings_listener.status !== app_consts.IDLE)
    {
      if (update_stock_movement_suspension_settings_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        if (update_stock_movement_suspension_settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(update_stock_movement_suspension_settings_listener.message);
          messageToast(update_stock_movement_suspension_settings_listener.message, app_consts.FAIL);
        } else if (update_stock_movement_suspension_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_stock_movement_suspension_settings();
          setEditMode(false);
        }
        setUpdateLoading(false);
        dispatch(reset_update_stock_movement_suspension_settings());
      }
    }
  }, [update_stock_movement_suspension_settings_listener]);


  return (
    <>
      <Modal isOpen={open} toggle={update_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md"}>
        <ModalHeader toggle={update_loading || loading ? "" : closeModal}>Stock Movement Suspension Settings</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieveing Stock Movement Suspension Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <div className='mt-4'>
                      </div>
                      {
                        editMode ?
                          <>
                            <Row className="gy-4">
                              {/* Employee Dashboard Disable */}
                              <Col md={12}>
                                <div className="p-3 border rounded">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <label
                                      className="form-label mb-0 fw-medium"
                                      htmlFor="disable_on_employee_dashboard"
                                    >
                                      Disable on Employee Dashboard
                                    </label>
                                    <div className="form-check form-switch">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="disable_on_employee_dashboard"
                                        checked={formData?.disable_on_employee_dashboard}
                                        onChange={() =>
                                          setFormData({
                                            ...formData,
                                            disable_on_employee_dashboard: !formData?.disable_on_employee_dashboard,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>

                                  {formData?.disable_on_employee_dashboard && (
                                    <TextInput
                                      label="Employee Dashboard Message"
                                      type="text"
                                      id_val="employee_dashboard_message"
                                      value={formData.employee_dashboard_message}
                                      name="employee_dashboard_message"
                                      handleChange={handleChange}
                                      helper={"(Optional)"}
                                      colSize={12}
                                    />
                                  )}
                                </div>
                              </Col>

                              {/* Webstore Disable */}
                              <Col md={12}>
                                <div className="p-3 border rounded bg-light">
                                  <div className="d-flex align-items-center justify-content-between mb-2">
                                    <label
                                      className="form-label mb-0 fw-medium"
                                      htmlFor="disable_on_webstore"
                                    >
                                      Disable on Webstore
                                    </label>
                                    <div className="form-check form-switch">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="disable_on_webstore"
                                        checked={formData?.disable_on_webstore}
                                        onChange={() =>
                                          setFormData({
                                            ...formData,
                                            disable_on_webstore: !formData?.disable_on_webstore,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>

                                  {formData?.disable_on_webstore && (
                                    <TextInput
                                      label="Webstore Message"
                                      type="text"
                                      id_val="webstore_message"
                                      value={formData.webstore_message}
                                      name="webstore_message"
                                      handleChange={handleChange}
                                      helper={"(Optional)"}
                                      colSize={12}
                                    />
                                  )}
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <Row className="g-4 mt-4">
                              {update_error && (
                                <div className="mb-3 w-100">
                                  <Alert color="danger" className="alert-icon">
                                    <Icon name="alert-circle" /> {update_error}{" "}
                                  </Alert>
                                </div>
                              )}
                              <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                <Button className='mx-2' onClick={() => setEditMode(false)} disabled={update_loading} color="gray">
                                  Cancel
                                </Button>
                                <Button onClick={handleUpdate} disabled={
                                  (update_loading)
                                } color="primary">
                                  {update_loading ? <Spinner size="sm" color="light" /> : "Update Stock Movement Suspension Settings."}
                                </Button>
                              </Col>
                            </Row>
                          </>
                          :
                          <>
                            {
                              page_data && page_data?.settings ?
                                <>
                                  <div className="m-auto d-flex flex-row justify-content-start align-center my-4" >
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData({ ...initial_state, disable_on_webstore: (page_data?.settings?.disable_on_webstore === true || page_data?.settings?.disable_on_webstore === "true") || false, disable_on_employee_dashboard: (page_data?.settings?.disable_on_employee_dashboard === true || page_data?.settings?.disable_on_employee_dashboard === "true") || false, webstore_message: page_data?.settings?.webstore_message, employee_dashboard_message: page_data?.settings?.employee_dashboard_message }); }} color="primary" size="sm">
                                      Edit Stock Movement Suspension Settings
                                    </Button>
                                  </div>
                                  <Row className="g-4">
                                    <TextInput
                                      label="Disabled on Employee Dashboard"
                                      type="text"
                                      id_val="disable_on_employee_dashboard"
                                      value={(page_data?.settings?.disable_on_employee_dashboard === true || page_data?.settings?.disable_on_employee_dashboard === "true") ? `YES` : "NO"}
                                      colSize="12"
                                      disabled
                                      name="disable_on_employee_dashboard"
                                    />
                                    {
                                      (page_data?.settings?.disable_on_employee_dashboard === true || page_data?.settings?.disable_on_employee_dashboard === "true") && (
                                        <>
                                          <TextInput
                                            label="Employee Dashboard Message"
                                            type="text"
                                            id_val="employee_dashboard_message"
                                            value={page_data?.settings?.employee_dashboard_message || "--"}
                                            colSize="12"
                                            disabled
                                            name="employee_dashboard_message"
                                          />
                                        </>
                                      )
                                    }
                                    <TextInput
                                      label="Disabled on Webstore"
                                      type="text"
                                      id_val="disable_on_webstore"
                                      value={(page_data?.settings?.disable_on_webstore === true || page_data?.settings?.disable_on_webstore === "true") ? `YES` : "NO"}
                                      colSize="12"
                                      disabled
                                      name="disable_on_webstore"
                                    />
                                    {
                                      (page_data?.settings?.disable_on_webstore === true || page_data?.settings?.disable_on_webstore === "true") && (
                                        <>
                                          <TextInput
                                            label="Webstore Message"
                                            type="text"
                                            id_val="webstore_message"
                                            value={page_data?.settings?.webstore_message || "--"}
                                            colSize="12"
                                            disabled
                                            name="webstore_message"
                                          />
                                        </>
                                      )
                                    }
                                  </Row>
                                </>
                                :
                                <>
                                  <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                                    <div className="text-soft fw-bold my-4" style={{ fontSize: 18 }}>No Suspension Settings have been Set</div>
                                    <Button onClick={(e) => { e.preventDefault(); setEditMode(true); setFormData(initial_state); }} color="primary" size="sm">
                                      Add Stock Suspension Settings
                                    </Button>
                                  </div>
                                </>
                            }
                          </>
                      }
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewStockMovementSuspensionSettingsModal;